export const ASSET_PAGE_TITLE = "Document Assets";
export const ASSET_PAGE_URL = "assets";

export const ASSET_COLUMN_CONFIG = [
  {
    id: "tagsType",
    label: "Tags",
    isActive: false,
  },
  {
    id: "docStatus",
    label: "Status",
    isActive: true,
  },
  {
    id: "recipients",
    label: "Recipients",
    isActive: true,
  },
  {
    id: "pipelineStatus",
    label: "Pipeline status",
    isActive: false,
  },
  {
    id: "owner",
    label: "Owner",
    isActive: true,
  },
  {
    id: "modifiedBy",
    label: "Last updated",
    isActive: true,
  },
  {
    id: "docuId",
    label: "Document ID",
    isActive: false,
  },
  // {
  //   id: "contact",
  //   label: "Contact",
  //   isActive: false,
  // },
  // {
  //   id: "turnarounddate",
  //   label: "Turn around date",
  //   isActive: false,
  // },
];

export const COLORS = [
  "#ffffff",
  "#000000",
  "#333333",
  "#888888",
  "#3333ff",
  "#66ccff",
  "#ff001c",
  "#faff00",
  "#9cd326",
  "#427d50",
  "#72c9c5",
  "#9dacbb",
  "#9795ff",
  "#7053c9",
  "#740e0e",
  "#ff0078",
  "#795449",
  "#e26d3f",
  "#f1cb45",
  "#bea938",
  "#99218d",
];

export const ASSET_ITEM_TYPES = {
  DOCUMENT: "DOC_EDITOR",
  DOCUMENT_FORM: "DOC_FORM",
  DOC_MASTER_FORM: "DOC_MASTER_FORM",
  EXTERNAL_QUOTE: "eq",
  FOLDER: "DIR",
  PDF: "PDF",
};

export const ASSET_ITEM_SETTING_OPTIONS = [
  {
    id: "delete",
    name: "Delete",
    argument: null,
    icon: ["far", "trash-alt"],
    iconClassName: "icon-trash-alt",
    isBottomLine: false,
  },
  {
    id: "rename",
    name: "Rename",
    argument: null,
    icon: ["far", "pen-square"],
    iconClassName: "icon-pen-square",
    isBottomLine: false,
  },
  {
    id: "blockchain",
    name: "Upload audit trail to blockchain",
    argument: null,
    icon: ["fab", "ethereum"],
    iconClassName: "ethereum-blockchain",
    isBottomLine: false,
  },
  {
    id: "addCollaborator",
    name: "Share with teammates",
    argument: null,
    icon: ["fas", "users"],
    iconClassName: "icon-users",
    isBottomLine: false,
  },
  {
    id: "sendToSomeone",
    name: "Send via email",
    argument: null,
    icon: ["far", "share-square"],
    iconClassName: "icon-folder",
    isBottomLine: false,
  },
  {
    id: "downloadDoc",
    name: "Download",
    argument: null,
    icon: ["far", "download"],
    iconClassName: "icon-folder",
    isBottomLine: false,
  },
  {
    id: "clone",
    name: "Clone document",
    argument: null,
    icon: ["far", "clone"],
    iconClassName: "icon-clone",
    isBottomLine: false,
  },
  {
    id: "moveToFolder",
    name: "Move to folder",
    argument: null,
    icon: ["fas", "arrow-circle-right"],
    iconClassName: "icon-folder",
    isBottomLine: false,
  },
];
export const ASSET_TOASTR_MESSAGE = {
  DELETE_DOCUMENT: "Selected items deleted successfully",
  FOLDER_MOVED: "Selected items moved successfully",
};

export const IMAGE_POSITION_OPTIONS = [
  "Top Left",
  "Top Right",
  "Top Center",
  "Center Left",
  "Center Right",
  "Center Center",
  "Bottom Left",
  "Bottom Right",
  "Bottom Center",
];

export const FONT_STYLES_WITH_OPTIONS = [
  "Roboto",
  "Baskerville",
  "EB Garamond",
  "Oswald",
  "Open Sans",
  "Montserrat",
  "Lato",
  "Inter",
  "Playfair Display",
  "Poppins",
  "Kalam",
  "Raleway",
  "Roboto Condensed",
  "Titillium Web",
  "Work Sans",
];

export const DOC_CTA_OPTIONS = [
  {
    img: "https://s3.amazonaws.com/webcontent.revv.so/images/create-doc/eSign.svg",
    eventName: "DOCUMENT_CREATED_ESIGN",
    title: "Create document",
    description:
      "Create documents from a template or build your own and send them for eSignature.",
    popupScreenTitle: "Create document",
    popupScreenSubTitle:
      "Select a template to create the document or start with a blank document",
    popupScreenType: 2,
    popupScreenSize: "MEDIUM",
    upgradeAvilable: false,
  },
  {
    img: "https://s3.amazonaws.com/webcontent.revv.so/images/create-doc/upload-PDF.svg",
    eventName: "DOCUMENT_CREATED_UPLOAD",
    title: "Upload a PDF or a .docx",
    description:
      "Upload a PDF, a fillable PDF or a .docx to request eSignatures on or share it in email for review.",
    popupScreenTitle: "Upload a PDF or a .docx",
    popupScreenSubTitle:
      "Browse files from your desktop and upload a PDF or a .docx to create the document",
    popupScreenType: 3,
    popupScreenSize: "MEDIUM",
    upgradeAvilable: false,
  },
  {
    img: "https://s3.amazonaws.com/webcontent.revv.so/images/create-doc/send-email.svg",
    eventName: "DOCUMENT_CREATED_SHARE",
    title: "Send document in email ",
    description:
      "Create a document and send it to recipients as a secure link over email for review or collaboration.",
    popupScreenTitle: "Send document in email ",
    popupScreenSubTitle:
      "Select a template to create the document or start with a blank document",
    popupScreenType: 2,
    popupScreenSize: "MEDIUM",
    upgradeAvilable: true,
  },
  {
    img: "https://s3.amazonaws.com/webcontent.revv.so/images/create-doc/publish-link.svg",
    eventName: "DOCUMENT_CREATED_LINKS",
    title: "Publish a shareable link",
    description:
      "Get a shareable view-only live document link or publish a fillable form to the web. ",
    popupScreenTitle: "Publish a shareable link",
    popupScreenSubTitle:
      "Select a template to create the document or start with a blank document",
    popupScreenType: 2,
    popupScreenSize: "MEDIUM",
    upgradeAvilable: true,
  },
];

export const DOCUMENT_INTERNAL_STAGE = {
  DRAFT: { name: "Draft", color: "#6e7a8e", bg: "#ebf0f5" },
  INTERNAL_REVIEW: {
    name: "Pending internal approval",
    color: "#8e5a0a",
    bg: "#fde2dd",
  },
  APPROVED: { name: "Approved internally", color: "#347aa5", bg: "#d3eeff" },
  REJECTED: { name: "Rejected internally", color: "#a41c4e", bg: "#fde2dd" },
  "SENT_FOR_FILLING ESIGN": {
    name: "Sent to fill before eSignature ",
    color: "#8e5a0a",
    bg: "#ffeacb",
  },
  "SENT_FOR_FILLING ACCEPTANCE": {
    name: "Sent to fill before acceptance",
    color: "#8e5a0a",
    bg: "#ffeacb",
  },
  SENT_FOR_FILLING: {
    name: "Draft",
    color: "#6e7a8e",
    bg: "#ebf0f5",
  },
  "SENT ESIGN": {
    name: "Sent for eSignature ",
    color: "#8e5a0a",
    bg: "#ffeacb",
  },
  "SENT ACCEPTANCE": {
    name: "Sent for acceptance",
    color: "#8e5a0a",
    bg: "#ffeacb",
  },
  "COMPLETED ESIGN": { name: "All eSigned", color: "#0e6245", bg: "#cbf4c9" },
  "COMPLETED ACCEPTANCE": {
    name: "All accepted",
    color: "#0e6245",
    bg: "#cbf4c9",
  },
  COMPLETED: {
    name: "All accepted",
    color: "#0e6245",
    bg: "#cbf4c9",
  },
  "DECLINED ESIGN": {
    name: "eSignature declined",
    color: "#a41c4e",
    bg: "#fde2dd",
  },
  "DECLINED ACCEPTANCE": {
    name: "Acceptance declined",
    color: "#a41c4e",
    bg: "#fde2dd",
  },
};

export const DOC_STATUSES_FOR_FILTER = {
  draft: {
    label: "Draft",
    status: "DRAFT",
  },
  pending_internal_approval: {
    label: "Pending internal approval",
    status: "INTERNAL_REVIEW",
  },
  approved_internally: {
    label: "Approved internally",
    status: "APPROVED",
  },
  sent_to_fill_before_esignature: {
    label: "Sent to fill before eSignature",
    status: "SENT_FOR_FILLING_ESIGN",
    flow: "ESIGN",
  },
  sent_to_fill_before_acceptance: {
    label: "Sent to fill before acceptance",
    status: "SENT_FOR_FILLING_ACCEPTANCE",
    flow: "ACCEPTANCE",
  },
  sent_for_esignature: {
    label: "Sent for eSignature",
    status: "SENT_ESIGN",
    flow: "ESIGN",
  },
  sent_for_acceptance: {
    label: "Sent for acceptance",
    status: "SENT_ACCEPTANCE",
    flow: "ESIGN",
  },
  all_accepted: {
    label: "All accepted",
    status: "COMPLETED_ACCEPTANCE",
    flow: "ACCEPTANCE",
  },
  all_esigned: {
    label: "All eSigned",
    status: "COMPLETED_ESIGN",
    flow: "ESIGN",
  },
  esignature_declined: {
    label: "eSignature declined",
    status: "DECLINED_ESIGN",
    flow: "ESIGN",
  },
  acceptance_declined: {
    label: "Acceptance declined",
    status: "DECLINED_ACCEPTANCE",
    flow: "ACCEPTANCE",
  },
};
